import {forwardRef, useState} from "react";
import MDSnackbar from "../../../components/MDSnackbar";
import Modal from "@mui/material/Modal";
import MDBox from "../../../components/MDBox";
import Card from "@mui/material/Card";
import MDTypography from "../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import FormField from "../account/components/FormField";
import MDButton from "../../../components/MDButton";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from "@mui/material";
import Icon from "@mui/material/Icon";
import DataTable from "../../../examples/Tables/DataTable";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../examples/Footer";
import { useCountriesTable } from "./data";
import CustomService from "../../../services/custome.service";
import InputMask from "react-input-mask";
import validateForm from "../../../utils";




const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


function Countries() {
    const [clickedItemId, setClickedItemId] = useState(0);
    const [open, setOpen] = useState(false);

    const [errorMessage, setErrorMessage] = useState(false);

    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);

    const openInfoSB = () => setInfoSB(true);
    const closeInfoSB = () => setInfoSB(false);

    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [openDialog, setOpenDialog] = useState(false);

    const table = useCountriesTable(handleDelete);
    
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);
    const handleAgreeDeleteDialog = () => {
        CustomService.removeCountry(clickedItemId)
            .then((response) =>{
                console.log(response);
                openInfoSB();
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err);
                openErrorSB();
            });
    };


    function handleDelete(elem) {
        handleOpenDialog();
        setClickedItemId(elem.target.id);
    }

    const [disableAction, setDisableAction] = useState(true);
    const [countryName, setCountryName] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [countryShortName, setCountryShortName] = useState("");
    const [formData, setFormData] = useState({
         "country_name": { "validation":{is_required:true}, "error_status": false, "error_message":"", "value": ""},
         "country_short_name": {"validation":{is_required:true, max:3}, "error_status": false, "error_message":"", "value": ""},
         "country_code": {"validation":{is_required:true}, "error_status": false, "error_message":"", "value": ""},
     })
    const setValue = (source, valueOfElement) => {
        if(source === "country_code") setCountryCode(valueOfElement.replace(/[^0-9]/g, ""));
        if(source === "country_name") setCountryName(valueOfElement);
        if(source === "country_short_name") setCountryShortName(valueOfElement);
    }
    const saveDataClicked = (e) =>{
      e.preventDefault();

      if(!checkForm()){
          CustomService.insertCountry(countryName, countryCode, countryShortName )
            .then((response) =>{
                console.log(response);
                openInfoSB();
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err);
                openErrorSB();
            });
      }
      handleClose();
    }
    const onChangeInput = (element, source) => {
        let valueOfElement = element.target.value;
        setDisableAction(false);
        let errorObject = validateForm(formData[source]["validation"], source, valueOfElement)
        if(errorObject != null){
            setFormData(prevErrors => ({...prevErrors,
                        [source]: {
                            "validation":prevErrors[source]["validation"],
                            "error_status":errorObject["error"],
                            "error_message":errorObject["errorMessage"],
                            "value": valueOfElement}}))
        }
        setValue(source, valueOfElement);
    }
    const checkForm = () => {
        let is_check = false;
        for (const validationKey in formData) {
            let xData = validateForm(formData[validationKey]["validation"], validationKey, formData[validationKey]["value"])
            if(xData.error){
                is_check = true;
            }
        }
        setDisableAction(is_check);
        return is_check;
    }

    const renderSB = (
        <div>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Amenity System"
              content="Your data saved successfully"
              dateTime=""
              open={infoSB}
              onClose={closeInfoSB}
              close={closeInfoSB}
            />
            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={closeErrorSB}
              close={closeErrorSB}
            />
        </div>
    );

    const renderModal = () => {
        return <Modal open={open} onClose={handleClose} color={"warning"} >
          <MDBox sx={style}>
            <Card id="basic-info" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5">Insert Country</MDTypography>
              </MDBox>
              <MDBox component="form" pb={3} px={3} >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <FormField label="Country Name"
                               placeholder="Canada"
                               error={formData["country_name"].error_status}
                               helperText={formData["country_name"].error_message}
                               onChange={e => onChangeInput(e, "country_name")}  />
                  </Grid>
                  <Grid item xs={12} md={12}>
                      <FormField
                            onChange={e => onChangeInput(e, "country_short_name")}
                            error={formData["country_short_name"].error_status}
                            helperText={formData["country_short_name"].error_message}
                            label="Short Name"
                            placeholder="CA"  />
                  </Grid>
                  <Grid item xs={12} md={12}>
                      <InputMask mask="(+999)"  onChange={e => onChangeInput(e, "country_code")}  >
                          {() => <FormField
                                        error={formData["country_code"].error_status}
                                        helperText={formData["country_code"].error_message}
                                        label="Country Code"
                                        placeholder="1" />}
                      </InputMask>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <MDButton color={"info"} type={"submit"} size={"large"} onClick={saveDataClicked} >Save Data</MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>
    };

    const renderDialog = () => {
        return (
            <Dialog
                open={openDialog}
                keepMounted
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle><Icon color={"warning"} >warning</Icon>{" Delete confirmation"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure to delete this item ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={handleCloseDialog} >Disagree</MDButton>
              <MDButton onClick={handleAgreeDeleteDialog}  size={"large"}  color={"info"}  >Agree</MDButton>
            </DialogActions>
          </Dialog>
        )
    }

    const renderCountriesList = () => {
        return(
            <MDBox my={3}>
              {renderSB}
              {renderModal()}
              {renderDialog()}
              <MDBox  display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                <MDButton variant="gradient" color="info" size="large" onClick={handleOpen}>
                  new Country
                </MDButton>
              </MDBox>
              <Card>
                <DataTable showTotalEntries={true} table={table}  entriesPerPage={false} canSearch />
              </Card>
            </MDBox>
        )
    };

    return (
        <DashboardLayout>
          <DashboardNavbar />
            {renderCountriesList()}
          <Footer />
        </DashboardLayout>
    );


}

export default Countries;